module.exports = __webpack_public_path__ + "img/sandclock.b3cce809.svg";